import { companyApiRoute } from '@crm/shared/api';

import { TDealColumn } from '../model';

export const dealsBoardApiRoutes = {
    getDealsBoardRoute: () => companyApiRoute('crm/deals/board'),
    sortDealColumnRoute: () => companyApiRoute('crm-process-queue'),
    editColumnDataRoute: (columnId: TDealColumn['id']) =>
        companyApiRoute(`/crm/deal-column/${columnId}`),
    deleteColumnRoute: () => (columnId: TDealColumn['id']) =>
        companyApiRoute(`/crm/deal-column/${columnId}`),
    createColumnRoute: () => companyApiRoute('crm/deal-column'),
};
